"use client";

import {
  createContext,
  PropsWithChildren,
  startTransition,
  useEffect,
  useState,
} from "react";
import { v4 } from "uuid";

type BuilderFormsContextType = {
  correlationId: string;
};

export const BuilderFormsContext = createContext<
  BuilderFormsContextType | undefined
>(undefined);

export const BuilderFormsContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [correlationId, setCorrelationId] = useState("");

  useEffect(() => {
    startTransition(() => {
      setCorrelationId(v4());
    });
  }, []);

  return (
    <BuilderFormsContext value={{ correlationId }}>
      {children}
    </BuilderFormsContext>
  );
};
